var _use, _symbol;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 85 85",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 2.5,
    y: 2.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#00d8ff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.937,
    cy: 39.951,
    r: 6.689
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.667 40c0-8.495 16.651-15.333 37.333-15.333S77.334 31.506 77.334 40 60.683 55.334 40 55.334 2.667 48.495 2.667 40zM6 40c0-6.648 15.164-12 34-12s34 5.352 34 12-15.164 12-34 12S6 46.648 6 40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.335 7.669c7.357-4.247 21.604 6.753 31.946 24.665s12.744 35.751 5.388 39.998-21.604-6.753-31.946-24.665-12.744-35.751-5.388-39.998zm1.667 2.887C28.759 7.232 40.976 17.688 50.394 34s12.365 32.121 6.608 35.445S39.027 62.313 29.609 46 17.244 13.88 23.002 10.556z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.669 7.67c7.357 4.247 4.954 22.087-5.388 39.998S28.692 76.581 21.335 72.334s-4.954-22.087 5.388-39.998S51.312 3.423 58.669 7.67zm-1.667 2.887c5.757 3.324 2.81 19.132-6.608 35.445S28.759 72.771 23.002 69.447s-2.81-19.132 6.608-35.445S51.245 7.233 57.002 10.557z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.4803bac2e49aec516b73ea899b3820ae.svg";
export { ForwardRef as ReactComponent };